import { createRoot } from 'react-dom/client';
import './index.css';
import { initLanguage } from './internationalization';
import App from './App';
import { AuthProvider } from './infrastructure/auth0/AuthProvider';

initLanguage();

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <AuthProvider>
      <App />
    </AuthProvider>
  );
}
